import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import GeneralSearchComponent from '../../components/GeneralCRUDComponent/GeneralSearchComponent/GeneralSearchComponent';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  AccessLevel,
  IStatisticsStore,
} from '../../mobx-store/storeInterfaces/statisticsInterface';
import styles from './statistics.module.scss';
import UpdateMembershipIdModal from '../../components/modals/updateMemberShipModal';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import { AuthStore } from 'mobx-store/stores/authStore';
import { ROLES } from 'components/NavBar/NavigationItems/routes';
import AlertDialog from 'components/Dialog/alertDialog';
import UpdateWalletPhoneNumber from 'screens/updateWalletNumberScreen';
import AddOnlineAccumulation from 'screens/addOnlineAccumulationScreen';
import {
  withRouter, RouteComponentProps
} from 'react-router';
interface IProps {
  history?: any;
  statisticsStore?: IStatisticsStore;
  authStore?: AuthStore;
}

interface IState {
  pageNumber: number;
  totalNumberOfPages: number;
  pageSize: number;
  searchTitle: string;
  open: boolean;
  currentUserId: number;
  openSyncKYCStatus: boolean;
  phoneModal: boolean;
  accumulationModal: boolean;
  selectedUserId: number | null;
  alertOpen: boolean;
}

@inject('statisticsStore')
@inject('authStore')
@observer
class Users extends Component<IProps & RouteComponentProps, IState> {
  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];
  

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    
    this.state = {
      openSyncKYCStatus: false,
      open: false,
      currentUserId: 0,
      pageNumber: 1,
      totalNumberOfPages: 1,
      pageSize: 50,
      searchTitle: '',
      phoneModal: false,
      accumulationModal: false,
      selectedUserId: null,
      alertOpen: false
    };

    this.props.statisticsStore?.clearUsersList();
  }

  componentDidMount(): void {
    this.searchUsers();
  }

  getStatisticsTableHeader = () => {
  const tableHeader =   [
    {
      title: translate('statisticsListNameColumnTitle'),
    },
    {
      title: translate('statisticsListMemberShipColumnTitle'),
    },
    {
      title: translate('statisticsListPhoneNumberColumnTitle'),
    },
    {
      title: translate('statisticsListIsMainMemberColumnTitle'),
    },
    {
      title: 'Access Level',
    },
    {
      title: 'Created At',
    },
    {
      title: translate('details'),
    }
  ];

  return tableHeader;
};

  getStatisticsTableData = () => this.props.statisticsStore!.usersList.map(user =>{ 
   return {
     ...user,
     isMainMember: user.isMainMember ? 'True' : 'False',
     details: translate('details'),
   } 
  });

  handleClickOpenSync = () => {
    this.setState({
      openSyncKYCStatus: true,
    });
  };
  handleAgreeSync = () => {
  };

  renewalsDetails = (index: number) => {
    const userId =  this.props.statisticsStore!.usersList[index].userId;
    this.props.history.push({
      pathname: `/users/${userId}/renewals`
    });
  }

  syncUserStatusClicked = async (index: number, key: string) => {
    this.handleClickOpenSync();
    this.handleAgreeSync = () => {
      this.props.authStore!.checkUserKYCStatus(this.props.statisticsStore!.usersList[index].membershipId)
        .then(async () => {
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 8000, 'success');
        })
        .catch((error: any) => {
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
      this.setState({
        openSyncKYCStatus: false,
      });
    };
};
userWifiPaymentDetails = (index: number) => {
  const { userId } = this.props.statisticsStore!.usersList[index];
  this.props.history.push({
    pathname: `/users/${userId}/wifi-packages`
  });
};
  getStatisticsTableCellTypes = (): TableCellTypes[] => {
    const tableCells: TableCellTypes[] = [
      {
        cellType: 'Text',
        key: 'firstName',
      },
      {
        cellType: 'Text',
        key: 'membershipId',
      },
      {
        cellType: 'Text',
        key: 'phoneNumber',
      },
      {
        cellType: 'Text',
        key: 'isMainMember',
      },
      {
        cellType: 'Text',
        key: 'accessLevel',
      },
      {
        cellType: 'Text',
        key: 'createdAt',
      },
      {
        cellType: 'Button',
        key: 'details',
        onClick: index => {
          const userId =  this.props.statisticsStore!.usersList[index].userId;
          this.props.history.push({
            pathname: `/users/${userId}`
          });
        },
      },
    ];   
    return tableCells;
  };

  asyncSetState = async<K extends keyof IState>(state: Pick<IState, K>) => new Promise((res) => {
    this.setState({
      ...state,
    }, () => res());
  });

  searchUsers = async () => {
    // if there is something in the search bar, paginate with this filter
    if (this.state.searchTitle.length > 0) {
      await this.props.statisticsStore!.getAllUsers(this.state.pageNumber, this.state.pageSize, false, this.state.searchTitle, false);
    } else {
      await this.props.statisticsStore!.getAllUsers(this.state.pageNumber, this.state.pageSize, false, '', false);
    }
  };

  leftArrowClicked = async () => {
    await this.asyncSetState({
      pageNumber: this.state.pageNumber - 1,
    });
    this.searchUsers();
  };

  rightArrowClicked = async () => {
    await this.asyncSetState({
      pageNumber: this.state.pageNumber + 1,
    });
    this.searchUsers();
  };

  setTotalPagesNumber = async (totalNumber: number) => {
    const numberOfPages = Math.ceil(
      totalNumber / this.state.pageSize,
    );
    await this.asyncSetState({
      totalNumberOfPages: numberOfPages,
    });
  };

  handleSearchChanged = async (title: string) => {
    await this.asyncSetState({
      pageNumber: 1,
      searchTitle: title,
    });
    if (title.length === 0) {
      this.props.statisticsStore!.usersList = [];
    } else {
      await this.props.statisticsStore!.getAllUsers(this.state.pageNumber, this.state.pageSize, false, title, false);
      this.setTotalPagesNumber(this.props.statisticsStore!.numberOfUsers);
    }
  };
;

  render() {
    this.tableHeader = this.getStatisticsTableHeader();
    this.tableData = this.getStatisticsTableData();
    this.tableCellTypes = this.getStatisticsTableCellTypes();
    return (
      <div className={styles.generalContainer}>
        <div>
          <GeneralSearchComponent
            onSearchClick={this.handleSearchChanged}
            searchBy="title"
          />
        </div>
        <div>
          <GeneralTableComponent
            emptyMessage={translate('noSearchWord', {
            })}
            tableHeader={this.tableHeader}
            tableData={this.tableData}
            tableCellTypes={this.tableCellTypes}
            loading={this.props.statisticsStore!.loading || this.props.authStore?.logging}
            hadPagination
            paginationAction={{
              handleClickLeftArrow: this.leftArrowClicked,
              handleClickRightArrow: this.rightArrowClicked,
              pageNumber: this.state.pageNumber,
              totalNumberOfPages: this.state.totalNumberOfPages,
            }}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(Users);
